import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { color as colorTokens } from '@spotify-internal/encore-foundation';
import Svg from "./Svg";

function isColorToken(color) {
  return color !== undefined && colorTokens.hasOwnProperty(color);
}
/**
 *
 * @example ./ICONS.md
 */


export default function Icon(_ref) {
  var _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? 24 : _ref$iconSize,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["iconSize", "color"]);

  return React.createElement(Svg, Object.assign({
    role: "img",
    height: iconSize,
    width: iconSize,
    iconSize: iconSize,
    viewBox: "0 0 24 24",
    iconColor: isColorToken(color) ? colorTokens[color] : color
  }, props));
}